import { Panel } from '@efira/ui';

import { useCurrentUser } from '../auth/session';

/** Настройки аккаунта - заглушка: содержимое появится вместе с тарифами и каналами. */
export function AccountZone() {
  const { user } = useCurrentUser();

  return (
    <Panel title="Аккаунт" subtitle="Имя, почта и часовой пояс — как указаны при регистрации">
      <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 text-sm">
        <dt className="text-foreground/75">Имя</dt>
        <dd>{user?.name ?? '-'}</dd>
        <dt className="text-foreground/75">Почта</dt>
        <dd>{user?.email ?? '-'}</dd>
        <dt className="text-foreground/75">Часовой пояс</dt>
        <dd>{user?.timezone ?? 'UTC'}</dd>
      </dl>

      <p className="text-foreground/80 text-sm">
        Смена пароля и часового пояса — скоро. Управление тарифом появится вместе с оплатой Pro.
      </p>
    </Panel>
  );
}
